import * as React from 'react';
import dwhExport from '~/api/dwhExport';
import { DWH_EVENTS, PARENTAL_CONTROLS } from '~/const';
import { ParentalControlPlace } from '~/types/common';
import { openUrl } from '~/utils/settings';

export const handleClick = (event: MouseEvent | React.MouseEvent) => {
    let target = event.target as HTMLLinkElement;
    if (target.tagName.toLowerCase() !== 'a') {
        target = target.parentNode as HTMLLinkElement;
    }
    if (target.tagName.toLowerCase() === 'a' && target.href) {
        event.stopPropagation();
        event.preventDefault();
        const type = target.dataset.type;
        const place = target.dataset.place;
        if (type === PARENTAL_CONTROLS && (place === ParentalControlPlace.FOOTER || place === ParentalControlPlace.PURCHASE_BLOCK)) {
            dwhExport.send(DWH_EVENTS.OPEN_PARENTAL_CONTROL_PAGE, { place });
        }
        openUrl(target.href);
    }
};

const useDelegationClickForLinkHandler = (ref: React.RefObject<HTMLElement>, deps: React.DependencyList = []) => {
    React.useEffect(() => {
        if (!ref || !ref.current) {
            return;
        }

        ref.current.addEventListener('click', handleClick);

        return () => ref.current?.removeEventListener('click', handleClick);
    }, deps);
};

export default useDelegationClickForLinkHandler;
